import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Using Google Fonts CDN for Montserrat
export const MontserratFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2",
    descriptors: { style: "normal", weight: "400" },
  },
  {
    uri: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyyTh89Y.woff2",
    descriptors: { style: "normal", weight: "500" },
  },
  {
    uri: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyyTh89Y.woff2",
    descriptors: { style: "normal", weight: "600" },
  },
  {
    uri: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WdhyyTh89Y.woff2",
    descriptors: { style: "normal", weight: "700" },
  },
];